import { useCallback, useEffect, useState } from "react";



const AUTO_SCROLL_MS = 4500;

const BANNER_IMAGES = [
  {
    src: "/banners/banner1.png",
    alt: "Banner 1",
  },
  {
    src: "/banners/banner2.png",
    alt: "Banner 2",
  },
  {
    src: "/banners/banner1.png",
    alt: "Banner 3",
  },
  {
    src: "/banners/banner1.png",
    alt: "Banner 4",
  },
];

function BannerCarousel() {
  const [active, setActive] = useState(0);
  const total = BANNER_IMAGES.length;

  const goTo = useCallback(
    (index) => {
      setActive((index + total) % total);
    },
    [total]
  );

  useEffect(() => {
    if (total <= 1) return;

    const timer = setInterval(() => {
      setActive((current) => (current + 1) % total);
    }, AUTO_SCROLL_MS);

    return () => clearInterval(timer);
  }, [total]);

  return (
    <section className="banner scroll-reveal" aria-label="Promotional banners">
      <div className="container-x">
        <div className="banner-carousel scroll-reveal" data-reveal-delay="1">
          <div
            className="banner-track"
            style={{ transform: `translateX(-${active * 100}%)` }}
          >
            {BANNER_IMAGES.map((slide, index) => (
              <div key={index} className="banner-slide">
                <img src={slide.src} alt={slide.alt} loading="lazy" />
              </div>
            ))}
          </div>

          {total > 1 && (
            <div
              className="banner-dots"
              role="tablist"
              aria-label="Banner slides"
            >
              {BANNER_IMAGES.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  role="tab"
                  aria-label={`Go to banner ${index + 1}`}
                  aria-selected={active === index}
                  className={`banner-dot${
                    active === index ? " is-active" : ""
                  }`}
                  onClick={() => goTo(index)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default BannerCarousel;
